export default __webpack_public_path__ + "static/media/foot-left-front.1c1954c4.png";